/**
 * 主动气泡样式 mixin
 * 样式来源：theme.entryTipStyle（与 SDK 入口引导气泡共用同一套配置）
 * 通过根节点注入 CSS 变量，组件内用 var(--agent-tip-*) 消费
 */

/**
 * 将图片 URL 转成 CSS url()
 * @param {string} [image]
 * @returns {string}
 */
function toCssUrl(image) {
  return image ? `url(${image})` : '';
}

/**
 * 仅写入有值的 CSS 变量，避免空字符串覆盖 var() 默认值
 * @param {Object} vars
 * @returns {Object}
 */
function pickCssVars(vars) {
  const result = {};
  Object.keys(vars).forEach(key => {
    const val = vars[key];
    if (val !== '' && val != null) {
      result[key] = val;
    }
  });
  return result;
}

export default {
  props: {
    /**
     * 与 theme.entryTipStyle 同构
     * @see configs/officialTopupNew/payAssistant.js THEME_PRESETS.*.entryTipStyle
     */
    tipStyle: {
      type: Object,
      default: () => ({}),
    },
    /** 助手名称（来自 entryTexts[lang].assistantName） */
    assistantName: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * 仅挂在根节点的 CSS 变量表（唯一允许的 :style）
     * 对应样式写在 AgentTipFrame / 各 tip 的 var(--agent-tip-*) 中
     */
    tipCssVars() {
      const s = this.tipStyle || {};
      const quietImg = toCssUrl(s.quietBtnImage);
      const gotItImg = toCssUrl(s.gotItBtnImage);
      const headerBg = s.headerBackground || s.background;
      const bodyBg = s.bodyBackground || s.background;
      return pickCssVars({
        // 外壳
        '--agent-tip-border': s.border,
        '--agent-tip-radius': s.borderRadius,
        // TipContainer 箭头读 --agent-entry-tip-bg
        '--agent-entry-tip-bg': bodyBg || headerBg,
        // 头部 / 正文分区背景（header 回退 background）
        '--agent-tip-header-bg': headerBg,
        '--agent-tip-body-bg': bodyBg,
        // 文案色
        '--agent-tip-text': s.textColor,
        '--agent-tip-name': s.nameColor || s.highlightColor,
        '--agent-tip-highlight': s.highlightColor,
        '--agent-tip-ai-badge-bg':
          s.aiBadgeBackground || s.gotItBtnBackground || s.highlightColor,
        // 左侧按钮
        '--agent-tip-quiet-btn-bg': s.quietBtnBackground,
        '--agent-tip-quiet-btn-image': quietImg,
        '--agent-tip-quiet-btn-color': s.quietBtnTextColor,
        '--agent-tip-quiet-btn-border': quietImg ? 'none' : '',
        // 右侧按钮
        '--agent-tip-gotit-btn-bg': s.gotItBtnBackground,
        '--agent-tip-gotit-btn-image': gotItImg,
        '--agent-tip-gotit-btn-color': s.gotItBtnTextColor,
        '--agent-tip-gotit-btn-border': gotItImg ? 'none' : '',
      });
    },
    tipAssistantImage() {
      return (this.tipStyle && this.tipStyle.assistantImage) || '';
    },
    tipMinimizeBtnImage() {
      return (this.tipStyle && this.tipStyle.minimizeBtnImage) || '';
    },
  },
};
